import { Autocomplete, Button, Tabs, Tab } from "@mui/material";
import { debounce, FormControl, Grid, LinearProgress, MenuItem, Select, SelectChangeEvent, SelectProps, TextField, } from "@mui/material";
import Box from "@mui/material/Box";
import * as React from "react";
import { useEffect, useRef, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import useAuth from "../context/AuthProvider";
import { FilingQueue } from "./PolicyDashboardElements/FilingQueue";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { ReadyToFilings } from "./PolicyDashboardElements/ReadyToFilings";
import { FMFilters, getCompletedFilings__Resp, ModelForFilters, NewCompletedFilingsModel } from "../models/NewCompletedFilingsModel";
import { OutstandingFilings } from "./PolicyDashboardElements/OutstandingFilings";
import Swal from "sweetalert2";
import moment from "moment";
import { writeXlsxFile, formatUtcToLocal } from "../helper/utils";
import { columnListDetailed, columnListShort, excelItemsAll, excelItemsDetailed, excelItemsShort } from "../components/Elements/ColumnList";
import { CompletedFilings } from "./PolicyDashboardElements/CompletedFilings";
import { GridFilterModel, GridSortModel } from "@mui/x-data-grid-pro";
import { isValid } from "../components/Elements/PolicyStatuses";
import { apiClient } from "../helper/api";
import { Search, Autorenew, Refresh, Clear } from "@mui/icons-material";

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}
const initValue: getCompletedFilings__Resp = {
  getCompletedFilings_Respdata: [],
  totalCount: 0
}

export enum FMTabs {
  OutStandingFiling = 8,
  ReadyToFiling = 6,
  CompletedFiling = 5
}

function TabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div role="tabpanel" hidden={value !== index} id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          {children}
        </Box>
      )}
    </div>
  );
}

function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

export default function BasicTabs() {
  const params = useParams();
  const navigate = useNavigate();
  const getTabFromParams = () => {
    const parsedTab = Number(params.LastTabId);
    return Object.values(FMTabs).includes(parsedTab as FMTabs)
      ? parsedTab
      : FMTabs.OutStandingFiling;
  };
  const [value, setValue] = React.useState(getTabFromParams);
  const { user } = useAuth();
  const token = user?.token;
  const [loading, setloading] = React.useState(false);
  const [newComponentDatawithCount, setNewComponentData] = useState<getCompletedFilings__Resp>(initValue)

  const [componentData, setcomponentData] = useState([]);
  
  const [stateId, setstateId] = useState(0);
  const [PolNumber, setpolNumber] = useState("");
  const [insuredName, setinsuredName] = useState("");
  const [customerId, setCustomerId] = useState(0);

  const PloicyNum = React.useRef("");
  const insName = React.useRef("");
  const stateData = React.useRef(0);
  const customerData = React.useRef(0);
  
  const effectiveDateEd = React.useRef("");
  const effectiveDateSt = React.useRef("");
  const [getCustomerPolicyIds, setCustomerPolicyIds] = React.useState<number[]>([]);
  const [currentPage, setCurrentPage] = React.useState(1);
  const [pageSize, setPageSize] = React.useState(50);
  const [filterModel, setFilterModel] = useState<{ items: { columnField: string, value: string, operatorValue: string }[], logicOperator?: 'and' | 'or' }>({ items: [], logicOperator: 'and' });
  const [sortModel, setSortModel] = useState([{ field: "", sort: "" }]);

  const [selectedRows, setSelectedRows] = useState<NewCompletedFilingsModel[] | null>([]);

  const getEndpointForTabValue = (tabValue: number) => {
    switch (tabValue) {
      case FMTabs.OutStandingFiling: return "Outstanding";
      case FMTabs.ReadyToFiling: return "ReadyToFile";
      case FMTabs.CompletedFiling: return "Completed";
      default: return null;
    }
  };

  const fetchDataMain = async (pageNumber: number, pageSize: number) => {
    setloading(true);
    const tabName = getEndpointForTabValue(value);
    const bodyParams = {
      partnersId: customerData.current,
      policyNumber: PloicyNum.current,
      stateId: stateData.current,
      insuredName: insName.current,
      pageNumber: pageNumber,
      pageSize: pageSize,
      tabName: tabName,
      filterModel: JSON.stringify(filterModel),
      field: sortModel?.[0]?.['field'] || '',
      sort: sortModel?.[0]?.['sort'] || '',
    };

    try {
      const res = await apiClient(`/PolicyDashBoard/getFilingQueueData`, {
        method: "POST",
        headers: new Headers({
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        }),
        body: JSON.stringify(bodyParams)
      })
      return res.data;
    } catch (error) {
      setloading(false);
      throw error;
    }
  };

  const fetchFilingQueueData = async (pageNumber: number, pageSize: number) => {
    setloading(true);
    const res = await fetchDataMain(pageNumber, pageSize)
    
    // Handle both possible property names for backward compatibility
    const dataProperty = res?.getCompletedFilings_Respdata || res?.getFilingQueueData_Respdata;
    
    if (!dataProperty) {
      setcomponentData([]);
      setNewComponentData(initValue);
      setloading(false)
      return;
    }
    setcomponentData(dataProperty);
    setNewComponentData(res);
    setloading(false);
  };

  const fetchData = async () => {
    setloading(true);
    const res = await fetchDataMain(currentPage, pageSize)
    
    // Handle both possible property names for backward compatibility
    const dataProperty = res?.getCompletedFilings_Respdata || res?.getFilingQueueData_Respdata;
    
    if (!dataProperty) {
      setcomponentData([]);
      setNewComponentData(initValue);
      setloading(false)
      return;
    }
    setcomponentData(dataProperty);
    setNewComponentData(res);
    setloading(false);
  };

  interface dataParams {
    customerPolicyId: number
  }
  const initCustValue: dataParams = {
    customerPolicyId: 0
  }

  const getCustomerPolicyDetails = async (customerPolicyId: number): Promise<string> => {
    try {
      setloading(true);
      const initCustValue = {
        customerPolicyId: customerPolicyId
      };
      var action = 'getPolicySubStatusByCustomerPolicyId';
      const res = await apiClient(`/PolicyDashBoard/${action}`,
        {
          method: "POST",
          headers: new Headers({
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          }),
          body: JSON.stringify(initCustValue)
        }
      );

      if (res?.data !== null && res?.data !== undefined) {
        setloading(false);
        return res.data.policySubStatus ?? '';
      } else {
        setloading(false);
        return '';
      }
    } catch (error) {
      setloading(false);
      return '';
    }
  };

  interface dataExportParams {
    customerPolicyIds: number[],
    option: string
  }

  const initValueExport: dataExportParams = {
    customerPolicyIds: [],
    option: ""
  }

  const getCustomerPolicyListbyTaxType = (action: string, customerPolicyIds: number[], option: string) => {
    setloading(true);
    if (customerPolicyIds.length === 0) {
      customerPolicyIds = getCustomerPolicyIds
    }

    if(customerPolicyIds.length == 0) {
      customerPolicyIds = newComponentDatawithCount.getCompletedFilings_Respdata?.map((m: any) => m.customerPolicyId) || [];
    }

    initValueExport.customerPolicyIds = customerPolicyIds;
    initValueExport.option = option;
    console.time('===getCustomerPolicyListbyTaxType===')
    apiClient(`/PolicyDashBoard/${action}`,
      {
        method: "POST",
        headers: new Headers({
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        }),
        body: JSON.stringify(initValueExport)
      }
    )
      .then((res) => {
        if (!res) return
        console.timeEnd('===getCustomerPolicyListbyTaxType===')
        if (res.data !== null) {
          let totalData: NewCompletedFilingsModel[] = [];
          if(res.data.outstandingFilingsData !== null){
            totalData = [...totalData, ...res.data.outstandingFilingsData]
          }
          if(res.data.completedFilingsData !== null){
            totalData = [...totalData, ...res.data.completedFilingsData]
          }
          if(res.data.closedFilingsData !== null){
            totalData = [...totalData, ...res.data.closedFilingsData]
          }
          if (totalData.length !== 0) handleExport(totalData, option, "ExportFilingsData");

          if (res.data.selectedFilingsData !== null) handleExport(res.data.selectedFilingsData, option, "CustomerPolicyData");
        }
        setSelectedRows([]);
      })
      .finally(() => {
        setloading(false);
      });
  };

  function convertDateFormat(dateStr: string): string | undefined {
    if (!dateStr || isNaN(Date.parse(dateStr))) {
      return undefined;
    }

    return formatUtcToLocal(dateStr, "MM/DD/YYYY");
  }
  

  const handleExport = async (items: NewCompletedFilingsModel[], option: string, fileName: string) => {
    console.log('option: ', option, 'fileName: ', fileName)
    console.time('===handleExport===')
    if (items.length === 0) {
      return
    }
    var filterExcelItem = option === "Short" ? excelItemsShort : option === "Detailed" ? excelItemsDetailed : option === "All" ? excelItemsAll : excelItemsShort;
    var filterColumnList = option === "Short" ? columnListShort : option === "Detailed" ? columnListDetailed : option === "All" ? columnListShort : columnListShort;
    fileName = option + '_' + fileName;
    const updates1: { [x: string]: any[] } = {}
    filterExcelItem.forEach(ex => {
      const headerRow = ex.columnOrder.map(idx => filterColumnList[idx].xlsHeader[0])
      updates1[fileName] = [headerRow]
    })

    items.forEach(item => {
      if (item.homeState === "NY" &&
        (item.transactionTypeName === "New Business" || item.transactionTypeName === "Renewal Business") &&
        item.filerNotes === "Filed on binder, need dec page") {
        item.filerNotes = "Need Dec Page";
      }
      const xlsHeaders: string[] = []
      Object.keys(item).map((field) => {
        if (!item[field as keyof NewCompletedFilingsModel]) return
        const column = filterColumnList.find(col => col.field === field)
        if (!column?.xlsHeader) return
        xlsHeaders.push(column.xlsHeader[0])
      })
      // date fromating
      item.effectiveDate = convertDateFormat(item.effectiveDate ?? '');
      item.dateFiled = convertDateFormat(item.dateFiled ?? '');
      item.dateInvoiceAdded = convertDateFormat(item.dateInvoiceAdded ?? '');
      item.invoiceDate = convertDateFormat(item.invoiceDate ?? '');
      item.dueDate = convertDateFormat(item.dueDate ?? '');
      item.policyExpDate = convertDateFormat(item.policyExpDate ?? '');
      item.paymentNoticeDate = convertDateFormat(item.paymentNoticeDate ?? '');
      item.diligentSearchToGMAC = convertDateFormat(item.diligentSearchToGMAC ?? '');
      item.firstRequest = convertDateFormat(item.firstRequest ?? '');
      item.secondRequest = convertDateFormat(item.secondRequest ?? '');
      item.thirdRequest = convertDateFormat(item.thirdRequest ?? '');

      const excelItem = filterExcelItem[0]
      const update1 = excelItem.columnOrder.map(idx => {
        const column = filterColumnList[idx]
        const field = column.field as keyof NewCompletedFilingsModel
        // const value = item[field]
        let value = item[field];
        if (
          field === "grossPremium" ||
          field === "taxAmt" ||
          field === "nonAdmittedPremium" ||
          field === "taxableFees" ||
          field === "nonTaxableFees" ||
          field === "taxBalance"
      ) {

        let cleanedValue = value?.replace(/[,\$]/g, "").trim();
        
        // If the value is in parentheses, it's negative, so handle that
        if (cleanedValue?.startsWith("(") && cleanedValue?.endsWith(")")) {
            cleanedValue = "-" + cleanedValue?.slice(1, -1); // Remove parentheses and add a negative sign
        }

        // Convert to number and pass to formatPrice
        const numericValue = parseFloat(cleanedValue);

        // If numericValue is a valid number, format it; otherwise, return the original string
        value = isNaN(numericValue) ? value : numericValue?.toString();
      }
        if (value === undefined || value === null) return
        switch (column.inputType) {
          case 'string':
            return value.toString()
          case 'custom':
            return value ? moment.utc(value as string).startOf('day').toDate() : undefined;
          case 'number':
            return +value
          case 'bool':
            return !!value
          default:
            return value
        }
      })
      updates1[fileName].push(update1)
      //updates1[excelItem.name].push(update1)
    })

    console.log({ updates1 })
    console.timeEnd('===handleExport===')

    filterExcelItem.forEach(excelItem => {
      if (!updates1[fileName] || updates1[fileName].length <= 1) return
      // const timeStamp = moment().format('MM.DD.YYYY')
      writeXlsxFile(updates1[fileName], `${fileName}.xlsx`)
    })
  }

  const initialUserdata = { partnersId: 0, customerName: "" };
  const [Customer, setCustomer] = useState([initialUserdata]);
  const fetchCustomer = () => {
    apiClient("/Partners/getPartners", {
      method: "GET",
      headers: new Headers({
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      }),
    })
      .then((responseJson) => {
        if (!responseJson) return
        // Do something with the response

        setCustomer(responseJson.data);
      })
  };

  const FMSelectCustomCustomer: React.FC<SelectProps> = ({
    variant,
    ...props
  }) => {
    const { user } = useAuth();
    const token = user?.token;

    return (
      <div>
        <FormControl fullWidth>
          <Autocomplete
            sx={{
              // Parent/Container Style
              marginTop: '-4px !important',
              
              // Target nested Input
              '& .MuiAutocomplete-input': {
                padding: '0px 4px 0px 5px !important',
              },
            }}
            options={Customer}
            getOptionLabel={(option) => option.customerName}
            onChange={(event, value) => setCustomerId(value?.partnersId ?? 0)}
            value={Customer.find(item => item.partnersId === customerId)}
            renderInput={(params) => {
              return <TextField
                sx={{
                  '.MuiFormLabel-root.Mui-focused': {
                    color: (typeof params.inputProps.value === 'string' && params.inputProps.value.length > 0) ? '#000' : '#cccccc !important'
                  },
                  '& .MuiInputBase-root': { marginTop: '5px !important' },
                  '& .MuiOutlinedInput-root': { padding: '4.5px 9px' },
                  '& .MuiFormLabel-root': { transform: 'translate(14px, 13px) scale(1)' },
                  '& .MuiInputLabel-shrink': { transform: 'translate(14px, -2px) scale(0.75)' },
                }}
                {...params}
                label="Client"
                InputLabelProps={{ ...params.InputLabelProps, shrink: (customerId > 0 || (typeof params.inputProps.value === 'string' && params.inputProps.value.length > 0)) ? true : false }}
              />
            }}
          />
          
          {/* <Select
            onChange={(e: SelectChangeEvent) => setCustomerId(Number(e.target.value))}
            value={customerId.toString()}
            id="test-select-label"
            autoWidth
            size="small"
            label={null}
            className="border-round custom-menu-item"
            IconComponent={ExpandMoreIcon}
            displayEmpty
          >
            <MenuItem key={0} value={0} className="custom-menu-item">
              Client
            </MenuItem>
            {Customer?.map((item, key) => (
              <MenuItem
                key={key}
                className="custom-menu-item"
                value={item.partnersId}
              >
                {item.customerName}
              </MenuItem>
            ))}
          </Select> */}
        </FormControl>
      </div>
    );
  };

  const initialStatedata = { stateId: 0, stateName: "" };
  const [States, setStates] = useState([initialStatedata]);

  const fetchStateData = () => {
    apiClient("/States/getStates", {
      method: "GET",
      headers: new Headers({
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      }),
    })
      .then((responseJson) => {
        if (!responseJson) return
        // Do something with the response

        setStates(responseJson.data);
      })
  };

  const FMSelectStateCustom: React.FC<SelectProps> = ({
    variant,
    ...props
  }) => {
    const { user } = useAuth();
    const token = user?.token;

    return (
      <FormControl fullWidth>
        <Autocomplete
          sx={{
            // Parent/Container Style
            marginTop: '-4px !important',
            
            // Target nested Input
            '& .MuiAutocomplete-input': {
              padding: '0px 4px 0px 5px !important',
            },
          }}
          options={States}
          getOptionLabel={(option) => option.stateName}
          onChange={(event, value) => setstateId(value?.stateId ?? 0)}
          value={States.find(item => item.stateId === stateId)}
          renderInput={(params) => {
            return <TextField
            sx={{
              '.MuiFormLabel-root.Mui-focused': {
                color: (typeof params.inputProps.value === 'string' && params.inputProps.value.length > 0) ? '#000' : '#cccccc !important'
              },
              '& .MuiInputBase-root': { marginTop: '5px !important' },
              '& .MuiOutlinedInput-root': { padding: '4.5px 9px' },
              '& .MuiFormLabel-root': { transform: 'translate(14px, 13px) scale(1)' },
              '& .MuiInputLabel-shrink': { transform: 'translate(14px, -2px) scale(0.75)' },
            }}
            {...params}
            label="Home State"
            InputLabelProps={{ ...params.InputLabelProps, shrink: (stateId > 0 || (typeof params.inputProps.value === 'string' && params.inputProps.value.length > 0)) ? true : false }}
            // InputLabelProps={{ ...params.InputLabelProps}}
          />
          }}
        />
        {/* <Select
          onChange={(e: SelectChangeEvent) => setstateId(Number(e.target.value))}
          value={stateId.toString()}
          size="small"
          id="test-select-label"
          label={null}
          className="border-round custom-menu-item"
          IconComponent={ExpandMoreIcon}
          displayEmpty
        >
          <MenuItem value={"0"} className="custom-menu-item">Home State</MenuItem>
          {States?.map((state, key) => (
            <MenuItem
              key={key}
              value={state.stateId}
              className="custom-menu-item"
            >
              {state.stateName}
            </MenuItem>
          ))}
        </Select> */}
      </FormControl>
    );
  };
  //const [selectedButton, setSelectedButton] = useState<number>(0);
  const [selectedButton, setSelectedButton] = useState<number>(getTabFromParams);

  const handleChange = (event: React.SyntheticEvent | undefined, newValue: number) => {
    setValue(newValue);
    setSelectedButton(newValue);

    if (params.LastTabId != String(newValue)) {
      navigate("/" + newValue);
    } else {
      setloading(false);
    }
  };

  useEffect(() => {
    const currentTab = getTabFromParams();
    setValue(currentTab);
    setSelectedButton(currentTab);

    setcomponentData([]);
    fetchStateData();
    fetchCustomer();
  }, []);

  useEffect(() => {
    fetchFilingQueueData(currentPage, pageSize);
  }, [currentPage, pageSize, filterModel, sortModel, value]);

  function RunSearch() {
    customerData.current = customerId;
    stateData.current = stateId;
    PloicyNum.current = PolNumber;
    insName.current = insuredName;
    fetchFilingQueueData(currentPage, pageSize);
  }

  const closePolicy = (id: number, action: string, value: number, message: string, isClosed: boolean, isRestoreToRec: boolean = false) => {
    Swal.fire({
      title: message,
      text: "This would revert the transaction to it's most recent status and tab",
      iconHtml: '<svg width="70" height="70" viewBox="0 0 62 62" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="31" cy="31" r="31" fill="#02A4E3"/><path d="M31.0003 25.6667V31M31.0003 36.3334H31.0137M44.3337 31C44.3337 38.3638 38.3641 44.3334 31.0003 44.3334C23.6365 44.3334 17.667 38.3638 17.667 31C17.667 23.6362 23.6365 17.6667 31.0003 17.6667C38.3641 17.6667 44.3337 23.6362 44.3337 31Z" stroke="white" strokeWidth="2" stroke-linecap="round" stroke-linejoin="round"/></svg>',
      showCancelButton: true,
      confirmButtonColor: '#02A4E3',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Proceed',
      customClass: {
        confirmButton: 'btn-radius',
        cancelButton: 'btn-radius',
        popup: 'card-radius'
      }
    })
      .then((result) => {
        if (result.isConfirmed) {
          apiClient(`/PolicyDashBoard/closeCustomerPolicy?custPolicyId=${id}&&isClosed=${isClosed}&&isRestoreToRec=${isRestoreToRec}`,
            {
              method: 'POST',

              headers: new Headers({
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`,
              })
            },
            {
              message: `Restore a customer policy status.`,
            }
          )
            .then((res) => {
              if (!res) return

              fetchFilingQueueData(currentPage, pageSize);
              Swal.fire({
                title: "Transaction Successfully restored",
                text: "",
                icon: "success",
                confirmButtonText: "OK",
              });
            }).finally(() => {
              setloading(false);
            });
        }
      })

  };

  function ClearSearch() {
    setloading(true);
    setpolNumber("");
    setinsuredName("");
    setCustomerId(0);
    setstateId(0);
    setloading(false);

    PloicyNum.current = "";
    insName.current = "";
    stateData.current = 0;
    customerData.current = 0;
    fetchFilingQueueData(currentPage, pageSize);
  }

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <div style={{ position: "fixed", top: "0", left: "0", zIndex: "9990", width: "100%" }}>
        {loading && <LinearProgress color="info" sx={{ backgroundColor: "#132D3D" }} />}
      </div>
      {/* Top bar: Tabs | Filters toggle | Refresh */}
      <Box
        sx={{
          display: "flex",
          flexWrap: "wrap",
          alignItems: "center",
          gap: 1.5,
          px: 2,
          py: 1.5,
          borderBottom: "1px solid #e2e8f0",
          backgroundColor: "#fafbfc",
          minHeight: 56,
          // mb: 1,
          marginLeft: { xs: '-24px', md: '0px' },
          marginRight: { xs: '-24px', md: '0px' },
        }}
      >
        {user?.userRoles.split(",").includes("Super Admin") ||
        user?.userRoles.split(",").includes("MISC State Reporter") ||
        user?.userRoles.split(",").includes("MISC Filer") ? (
          <>
            {/* Tabs: desktop only (md and up) */}
            <Tabs
              value={selectedButton}
              onChange={(_, newValue) => handleChange(undefined, newValue)}
              variant="scrollable"
              scrollButtons="auto"
              allowScrollButtonsMobile
              sx={{
                display: { xs: "none", sm: "flex" },
                minHeight: 48,
                "& .MuiTab-root": { textTransform: "none", fontWeight: 600, fontSize: "0.9375rem" },
                "& .Mui-selected": { color: "#2099d2" },
                "& .MuiTabs-indicator": { backgroundColor: "#2099d2", height: 3, borderRadius: "3px 3px 0 0", },
              }}
            >
              <Tab value={8} label="Outstanding Filings" />
              <Tab value={6} label="Ready to File" />
              <Tab value={5} label="Completed Filings" />
            </Tabs>
            {/* Select option for mobile view */}
            <FormControl
              size="small"
              sx={{
                display: { xs: "block", sm: "none" },
                minWidth: 160,
                "& .MuiOutlinedInput-notchedOutline": { borderColor: "#e2e8f0" },
                "& .MuiSelect-select": { fontWeight: 600, color: "#2099d2", py: 0.9 },
              }}
            >
              <Select
                value={selectedButton}
                onChange={(e) => handleChange(undefined, Number(e.target.value))}
                displayEmpty
                sx={{ textTransform: "none", fontSize: "0.9375rem" }}
              >
                <MenuItem value={8}>Outstanding Filings</MenuItem>
                <MenuItem value={6}>Ready to File</MenuItem>
                <MenuItem value={5}>Completed Filings</MenuItem>
              </Select>
            </FormControl>
            <Box sx={{ flex: 1, minWidth: 120 }} />
          </>
        ) : (
          <div className="col-lg-12 col-sm-12 d-flex justify-content-center align-items-center" style={{ minHeight: 48 }}>
            <span style={{ fontSize: "20px", fontWeight: 600 }}>Pending Documents</span>
          </div>
        )}
      </Box>

      {/* Expandable filter panel */}
      {user?.userRoles.split(",").includes("Super Admin") ||
      user?.userRoles.split(",").includes("MISC State Reporter") ||
      user?.userRoles.split(",").includes("MISC Filer") ? (
        <Box
          sx={{
            width: "100%",
            py: 2,
            px: 2,
          }}
        >
          <Grid
              container
              spacing={2}
              // alignItems="center"
              className="filter-grid"
              display="flex"
              // justifyContent="center"
            >
              <Grid item xl={2} lg={4} sm={6} xs={12}>
                <FMSelectCustomCustomer name="customer" />
              </Grid>
              <Grid item xl={2} lg={4} sm={6} xs={12}>
                <FMSelectStateCustom name="state" />
              </Grid>
              <Grid item xl={2} lg={4} sm={6} xs={12}>
                <TextField
                  name="Insured Name"
                  size="small"
                  value={insuredName}
                  label="Insured Name"
                  onChange={(e) => setinsuredName(e.target.value)}
                  fullWidth
                  variant="outlined"
                  sx={{
                    "& .MuiOutlinedInput-notchedOutline": { borderColor: "#c4c4c4" },
                    "& .MuiInputBase-root": { marginTop: '1px !important' },
                    "& .MuiInputBase-input": { padding: '4.5px 14px !important' },
                  }}
                />
              </Grid>
              <Grid item xl={2} lg={4} sm={6} xs={12}>
                <TextField
                  value={PolNumber}
                  name="PolicyNumber"
                  size="small"
                  label="Policy Number"
                  onChange={(e) => setpolNumber(e.target.value)}
                  fullWidth
                  variant="outlined"
                  sx={{
                    "& .MuiOutlinedInput-notchedOutline": { borderColor: "#c4c4c4" },
                    "& .MuiInputBase-root": { marginTop: '1px !important' },
                    "& .MuiInputBase-input": { padding: '4.5px 14px !important' },
                  }}
                />
              </Grid>
              <Grid item xs={12} sm="auto">
                <Box sx={{ display: "flex", gap: 1, flexWrap: "wrap" }}>
                  <Button
                    variant="contained"
                    size="medium"
                    onClick={() => { RunSearch(); }}
                    startIcon={<Search />}
                    sx={{
                      textTransform: "none",
                      fontWeight: 600,
                      backgroundColor: "#2099d2",
                      "&:hover": { backgroundColor: "#176990" },
                    }}
                  >
                    Search
                  </Button>
                  <Button
                    variant="outlined"
                    size="medium"
                    onClick={() => { ClearSearch(); }}
                    startIcon={<Clear />}
                    sx={{
                      textTransform: "none",
                      fontWeight: 600,
                      borderColor: "#e2e8f0",
                      color: "#475569",
                      "&:hover": { borderColor: "#2099d2", color: "#2099d2" },
                    }}
                  >
                    Clear
                  </Button>
                  <Button
                    variant="outlined"
                    size="medium"
                    onClick={() => window.location.reload()}
                    startIcon={<Refresh />}
                    sx={{
                      textTransform: "none",
                      fontWeight: 600,
                      borderColor: "#e2e8f0",
                      color: "#475569",
                      "&:hover": {
                        borderColor: "#2099d2",
                        backgroundColor: "#2099d214",
                        color: "#2099d2",
                      },
                    }}
                  >
                    Refresh
                  </Button>
                </Box>
              </Grid>
            </Grid>
        </Box>
      ) : null}

      <Box sx={{ width: "100%" }}>
        <Box position="relative">
          {loading && (<>
              <Box
                position="absolute"
                top={0}
                left={0}
                right={0}
                bottom={0}
                display="flex"
                alignItems="center"
                justifyContent="center"
                sx={{
                    backgroundColor: "rgba(250, 251, 252, 0.85)",
                    zIndex: 10,
                    border: "1px solid #e2e8f0",
                    borderRadius: 1,
                }}
            >
                <Box sx={{ width: "100%", maxWidth: 320 }}>
                    <LinearProgress color="info" sx={{ backgroundColor: "#e2e8f0", "& .MuiLinearProgress-bar": { backgroundColor: "#132D3D" } }} />
                    <Box sx={{ mt: 1.5, textAlign: "center" }}>
                        <span style={{ fontSize: "14px", fontWeight: 600, color: "#475569" }}>Loading...</span>
                    </Box>
                </Box>
            </Box>
          </>) }
          <div className={`${loading ? "invisible" : "visible"}`}>
            <TabPanel value={value} index={8}>
              {user?.userRoles.split(",").includes("Super Admin")
                || user?.userRoles.split(",").includes("MISC State Reporter")
                || user?.userRoles.split(",").includes("MISC Filer") ? (
                <OutstandingFilings
                  NewCompletedFilingsCL={newComponentDatawithCount}
                  fetchFilingQueueData={fetchFilingQueueData}
                  closePolicy={closePolicy}
                  getCustomerPolicyListbyTaxType={getCustomerPolicyListbyTaxType}
                  setSelectedRows={setSelectedRows}
                  selectedRows={selectedRows}
                  getCustomerPolicyDetails={getCustomerPolicyDetails}
                  setCurrentPage={setCurrentPage}
                  currentPage={currentPage}
                  setPageSize={setPageSize}
                  pageSize={pageSize}
                  sortModel={sortModel}
                  filterModel={filterModel}
                  setFilterModel={setFilterModel}
                  setSortModel={setSortModel}
                />
              ) : (
                <FilingQueue
                  filingData={componentData}
                  refreshDataAfterUpload={() => fetchData}
                  refreshDataMain={fetchData}
                  showPayouts={() => undefined}
                  sNo={undefined}
                />
              )}
            </TabPanel>

            <TabPanel value={value} index={5}>
              <CompletedFilings NewCompletedFilingsCL={newComponentDatawithCount}
                fetchFilingQueueData={fetchFilingQueueData}
                closePolicy={closePolicy}
                getCustomerPolicyListbyTaxType={getCustomerPolicyListbyTaxType}
                setPageSize={setPageSize}
                setSelectedRows={setSelectedRows}
                setCurrentPage={setCurrentPage}
                currentPage={currentPage}
                selectedRows={selectedRows}
                pageSize={pageSize}
                sortModel={sortModel}
                filterModel={filterModel}
                setFilterModel={setFilterModel}
                setSortModel={setSortModel}
              />
            </TabPanel>
            <TabPanel value={value} index={6}>
              {
                user?.userRoles.split(",").includes("Super Admin")
                  || user?.userRoles.split(",").includes("MISC State Reporter")
                  || user?.userRoles.split(",").includes("MISC Filer") ? (
                  <ReadyToFilings
                    NewCompletedFilingsCL={newComponentDatawithCount}
                    fetchFilingQueueData={fetchFilingQueueData}
                    closePolicy={closePolicy}
                    getCustomerPolicyListbyTaxType={getCustomerPolicyListbyTaxType}
                    getCustomerPolicyDetails={getCustomerPolicyDetails}
                    setSelectedRows={setSelectedRows}
                    selectedRows={selectedRows}
                    setCurrentPage={setCurrentPage}
                    currentPage={currentPage}
                    setPageSize={setPageSize}
                    pageSize={pageSize}
                    sortModel={sortModel}
                    filterModel={filterModel}
                    setFilterModel={setFilterModel}
                    setSortModel={setSortModel}
                  />
                ) : (
                  ""
                )}
            </TabPanel>
            <TabPanel value={value} index={7}>
              coming Soon
            </TabPanel>
          </div>
        </Box>
      </Box>
    </LocalizationProvider>
  );
}
